import { Grid, Skeleton } from "@mui/material";
import { motion } from "motion/react";

export default function QRCodePendingSkeleton() {
  return (
    <Grid
      container
      size={12}
      component={motion.div}
      key="pending"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Grid
        size="auto"
        sx={{
          display: "flex",
          flexDirection: "column",
          p: 2,
        }}
      >
        <Skeleton
          variant="rectangular"
          height={352}
          width={382}
          animation="wave"
          sx={{ borderRadius: 2 }}
        />
      </Grid>
      <Grid size="grow" sx={{ p: 2 }}>
        <Skeleton
          variant="rectangular"
          height={352}
          width={"100%"}
          animation="wave"
          sx={{ borderRadius: 2 }}
        />
      </Grid>
    </Grid>
  );
}
